import React, { useState, useEffect, useCallback } from 'react';
import {
  FaEnvelope, FaSearch, FaDownload, FaEye, FaTimes, FaReply,
  FaTrash, FaChevronLeft, FaChevronRight, FaCheckCircle, FaClock, FaInbox,
  FaExclamationTriangle, FaBuilding, FaPaperPlane, FaTag, FaCalendarAlt,
  FaCircle, FaArchive, FaCheckDouble, FaBell, FaHistory, FaStickyNote,
  FaEdit, FaSpinner,
} from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Navbar  from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';

import { API_URL as API } from '../config/api';
const SB_OPEN = 252; const SB_CLOSED = 74; const SB_GAP = 12;
const NB_HEIGHT = 68; const NB_TOP = 12;

const STATUS_CFG = {
  nouveau:  { label:'Nouveau',  color:'#fd7e14', bg:'rgba(253,126,20,.1)',  border:'rgba(253,126,20,.25)' },
  en_cours: { label:'En cours', color:'#fd7e14', bg:'rgba(253,126,20,.06)', border:'rgba(253,126,20,.18)' },
  repondu:  { label:'Répondu',  color:'#198754', bg:'rgba(25,135,84,.08)',  border:'rgba(25,135,84,.2)'   },
  archive:  { label:'Archivé',  color:'#8fa3b5', bg:'rgba(143,163,181,.08)',border:'rgba(143,163,181,.2)' },
};

const SUJET_TAGS = {
  'Formation':   { bg:'rgba(253,126,20,.08)', color:'#fd7e14' },
  'Inscription': { bg:'rgba(25,135,84,.08)',  color:'#198754' },
  'Devis':       { bg:'rgba(32,201,151,.08)', color:'#20c997' },
  'Partenariat': { bg:'rgba(25,135,84,.06)',  color:'#1a9e6e' },
  'Information': { bg:'rgba(143,163,181,.08)',color:'#5a6b82' },
  'Réclamation': { bg:'rgba(220,53,69,.08)',  color:'#dc3545' },
};

const AV_BG      = ['#1a2535','#157347','#1a9e6e','#5a3e9c','#b45309'];
const getAVBg    = s  => AV_BG[s.charCodeAt(0) % AV_BG.length];
const initials   = n  => n.split(' ').map(p=>p[0]).join('').slice(0,2).toUpperCase();
const fmtDate    = d  => new Date(d).toLocaleDateString('fr-FR',{day:'2-digit',month:'short',year:'numeric'});
const fmtDT      = d  => new Date(d).toLocaleString('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'});
const HISTO_C    = { recu:'#fd7e14',wait:'#fd7e14',email:'#198754',ok:'#198754',archive:'#8fa3b5',note:'#5a6b82' };

// ── Toast ─────────────────────────────────────────────────────────────────────
const useToast = () => {
  const [toasts, setToasts] = useState([]);
  const add = useCallback((msg, type='success') => {
    const id = Date.now();
    setToasts(p => [...p, {id,msg,type}]);
    setTimeout(() => setToasts(p => p.filter(t=>t.id!==id)), 4000);
  }, []);
  return { toasts, add };
};
const ToastContainer = ({ toasts }) => (
  <div style={{position:'fixed',bottom:24,right:24,zIndex:9999,display:'flex',flexDirection:'column',gap:8}}>
    {toasts.map(t => (
      <div key={t.id} style={{
        display:'flex',alignItems:'center',gap:12,padding:'13px 18px',borderRadius:12,minWidth:280,
        background:t.type==='success'?'linear-gradient(135deg,#0d1f14,#071a10)':t.type==='error'?'linear-gradient(135deg,#1f0d0d,#1a0707)':'linear-gradient(135deg,#0d1520,#071020)',
        border:`1px solid ${t.type==='success'?'rgba(25,135,84,.4)':t.type==='error'?'rgba(220,53,69,.4)':'rgba(253,126,20,.4)'}`,
        boxShadow:'0 16px 40px rgba(0,0,0,.4)',animation:'ct-toast .35s ease',
      }}>
        <span style={{fontSize:15,color:t.type==='success'?'#20c997':t.type==='error'?'#dc3545':'#fd7e14'}}>
          {t.type==='success'?'✓':t.type==='error'?'✕':'!'}
        </span>
        <p style={{flex:1,fontSize:13.5,fontWeight:500,color:'#eef2f7',margin:0}}>{t.msg}</p>
      </div>
    ))}
    <style>{`@keyframes ct-toast{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}`}</style>
  </div>
);

// ── Skeleton ──────────────────────────────────────────────────────────────────
const Sk = ({h=60, r=10}) => (
  <div style={{height:h,borderRadius:r,
    background:'linear-gradient(90deg,rgba(128,128,128,.07) 25%,rgba(128,128,128,.14) 50%,rgba(128,128,128,.07) 75%)',
    backgroundSize:'200% 100%',animation:'ct-shimmer 1.4s infinite'}} />
);

// ─────────────────────────────────────────────────────────────────────────────
const ContactAdmin = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const { toasts, add: toast } = useToast();

  const token   = localStorage.getItem('admin_token');
  const headers = { Authorization: `Bearer ${token}` };

  // ── State ─────────────────────────────────────────────────────────────────
  const [contacts,     setContacts]     = useState([]);
  const [stats,        setStats]        = useState({});
  const [loading,      setLoading]      = useState(true);
  const [loadingStats, setLoadingStats] = useState(true);
  const [currentPage,  setCurrentPage]  = useState(1);
  const [totalPages,   setTotalPages]   = useState(1);
  const [totalItems,   setTotalItems]   = useState(0);
  const [searchQuery,  setSearchQuery]  = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterTag,    setFilterTag]    = useState('all');

  const [selectedMsg,  setSelectedMsg]  = useState(null);
  const [showModal,    setShowModal]    = useState(false);
  const [modalTab,     setModalTab]     = useState('message');
  const [replyText,    setReplyText]    = useState('');
  const [noteText,     setNoteText]     = useState('');
  const [actionLoad,   setActionLoad]   = useState(null); // 'reply','note','statut-X','delete-X'

  // ── Thème ─────────────────────────────────────────────────────────────────
  const c = isDark ? {
    bg:'#090c16',card:'rgba(255,255,255,.04)',cardB:'rgba(255,255,255,.08)',
    text:'#c8d4e0',textDim:'#5a6b82',title:'#eef2f7',
    surface:'rgba(255,255,255,.05)',input:'rgba(255,255,255,.06)',inputB:'rgba(255,255,255,.12)',
    inputT:'#eef2f7',shadow:'0 4px 24px rgba(0,0,0,.4)',divider:'rgba(255,255,255,.07)',
    overlay:'rgba(0,0,0,.75)',
  } : {
    bg:'#f0f3f8',card:'#ffffff',cardB:'rgba(0,0,0,.07)',
    text:'#4d6070',textDim:'#8fa3b5',title:'#1a2535',
    surface:'rgba(0,0,0,.03)',input:'#f7f9fb',inputB:'rgba(0,0,0,.1)',
    inputT:'#1a2535',shadow:'0 2px 12px rgba(0,0,0,.06)',divider:'rgba(0,0,0,.07)',
    overlay:'rgba(15,23,42,.55)',
  };

  const mainML = `${SB_GAP+(sidebarOpen?SB_OPEN:SB_CLOSED)+12}px`;
  const mainPT = `${NB_TOP+NB_HEIGHT+12}px`;

  // ── Fetch ─────────────────────────────────────────────────────────────────
  const fetchStats = useCallback(() => {
    setLoadingStats(true);
    axios.get(`${API}/admin/contacts/stats`, {headers})
      .then(({data}) => setStats(data))
      .finally(() => setLoadingStats(false));
  }, []);

  const fetchContacts = useCallback(() => {
    setLoading(true);
    axios.get(`${API}/admin/contacts`, {headers, params:{
      page:currentPage, per_page:10,
      statut: filterStatus!=='all'?filterStatus:undefined,
      tag:    filterTag!=='all'?filterTag:undefined,
      search: searchQuery||undefined,
    }})
    .then(({data}) => {
      setContacts(data.data);
      setTotalPages(data.last_page);
      setTotalItems(data.total);
    })
    .finally(() => setLoading(false));
  }, [currentPage, filterStatus, filterTag, searchQuery]);

  useEffect(() => { fetchStats(); }, [fetchStats]);
  useEffect(() => { fetchContacts(); }, [fetchContacts]);
  useEffect(() => { setCurrentPage(1); }, [filterStatus, filterTag, searchQuery]);

  // ── Actions ───────────────────────────────────────────────────────────────
  const openModal = (msg, tab='message') => {
    setSelectedMsg({...msg}); setModalTab(tab);
    setShowModal(true); setReplyText(''); setNoteText('');
  };
  const closeModal = () => { setShowModal(false); setSelectedMsg(null); };

  const handleChangeStatut = async (id, statut) => {
    setActionLoad('statut-'+id);
    try {
      await axios.patch(`${API}/admin/contacts/${id}/statut`, {statut}, {headers});
      toast('Statut mis à jour');
      fetchContacts(); fetchStats();
      setSelectedMsg(p => p ? {...p, statut} : p);
    } catch { toast('Erreur', 'error'); }
    finally { setActionLoad(null); }
  };

  const handleReply = async () => {
    if (!replyText.trim()) return;
    setActionLoad('reply');
    try {
      await axios.post(`${API}/admin/contacts/${selectedMsg.id}/reply`, {reponse:replyText}, {headers});
      toast('Réponse envoyée avec succès ✓');
      const newRep = {auteur:'Admin CINEF', texte:replyText, date:fmtDT(new Date())};
      setSelectedMsg(p => ({...p,
        reponses:[...(p.reponses||[]), newRep],
        statut:'repondu',
        historique:[...(p.historique||[]), {action:'Réponse envoyée par email',icone:'email',date:fmtDT(new Date())}],
      }));
      setContacts(p => p.map(m => m.id===selectedMsg.id ? {...m,statut:'repondu'} : m));
      setReplyText('');
      fetchStats();
    } catch (e) {
      toast(e.response?.data?.message || 'Erreur lors de l\'envoi', 'error');
    }
    finally { setActionLoad(null); }
  };

  const handleAddNote = async () => {
    if (!noteText.trim()) return;
    setActionLoad('note');
    try {
      const {data} = await axios.post(`${API}/admin/contacts/${selectedMsg.id}/note`, {note:noteText}, {headers});
      toast('Note ajoutée');
      setSelectedMsg(p => ({...p,
        notes:[...(p.notes||[]), data.note],
        historique:[...(p.historique||[]), {action:'Note interne ajoutée',icone:'note',date:fmtDT(new Date())}],
      }));
      setNoteText('');
    } catch { toast('Erreur', 'error'); }
    finally { setActionLoad(null); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer définitivement ce message ?')) return;
    setActionLoad('delete-'+id);
    try {
      await axios.delete(`${API}/admin/contacts/${id}`, {headers});
      toast('Message supprimé');
      setContacts(p => p.filter(m=>m.id!==id));
      fetchStats();
      closeModal();
    } catch { toast('Erreur', 'error'); }
    finally { setActionLoad(null); }
  };

  const exportCSV = () => {
    const h = ['Ref','Nom','Entreprise','Email','Téléphone','Sujet','Tag','Statut','Date'];
    const rows = contacts.map(m => [m.ref,m.nom_complet,m.entreprise,m.email,m.telephone,`"${m.sujet}"`,m.tag||'',m.statut,m.created_at_human]);
    const csv = [h,...rows].map(r=>r.join(',')).join('\n');
    const a = document.createElement('a'); a.href = URL.createObjectURL(new Blob(['\uFEFF'+csv],{type:'text/csv;charset=utf-8'}));
    a.download = `contacts_${new Date().toISOString().split('T')[0]}.csv`; a.click();
  };

  const Spin = () => <FaSpinner style={{animation:'ct-spin .8s linear infinite',fontSize:13}} />;
  const inProg = k => actionLoad === k;

  const inputS = { padding:'9px 14px',background:c.input,border:`1.5px solid ${c.inputB}`,borderRadius:10,fontSize:13,color:c.inputT,outline:'none',fontFamily:"'Plus Jakarta Sans',sans-serif" };
  const Block  = ({title,children,style={}}) => (
    <div style={{background:c.card,border:`1px solid ${c.cardB}`,borderRadius:12,padding:'18px 20px',marginBottom:12,boxShadow:c.shadow,...style}}>
      {title && <div style={{fontSize:11,fontWeight:700,color:c.textDim,textTransform:'uppercase',letterSpacing:'.7px',marginBottom:14,paddingBottom:10,borderBottom:`1px solid ${c.divider}`}}>{title}</div>}
      {children}
    </div>
  );

  return (
    <div style={{background:c.bg,minHeight:'100vh',fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;font-family:'Plus Jakarta Sans',sans-serif}
        @keyframes ct-shimmer{from{background-position:200% 0}to{background-position:-200% 0}}
        @keyframes ct-fade{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
        @keyframes ct-up{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}
        @keyframes ct-fo{from{opacity:0}to{opacity:1}}
        @keyframes ct-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}

        .ct-main{transition:margin-left .28s cubic-bezier(.4,0,.2,1)}
        .ct-body{padding:20px 24px 48px;animation:ct-fade .4s ease}
        .ct-card-wrap:hover .ct-card-inner{transform:translateY(-1px)!important}
        .ct-card-inner{transition:all .2s}
        .mo-overlay{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:2000;padding:16px;animation:ct-fo .2s}
        .mo-panel{border-radius:18px;width:100%;max-width:860px;max-height:92vh;display:flex;flex-direction:column;overflow:hidden;animation:ct-up .28s cubic-bezier(.22,1,.36,1)}
        .mo-tab{display:flex;align-items:center;gap:7px;padding:8px 14px;border-radius:8px;border:none;font-size:13px;font-weight:600;cursor:pointer;transition:all .18s;font-family:'Plus Jakarta Sans',sans-serif}
        .ct-ta{width:100%;padding:11px 14px;border-radius:10px;font-size:13px;outline:none;resize:vertical;display:block;line-height:1.7;font-family:'Plus Jakarta Sans',sans-serif;transition:border-color .2s}
        .ct-ta:focus{border-color:#198754!important}
        .pg-btn{min-width:36px;height:36px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0 10px;transition:all .18s;font-family:'Plus Jakarta Sans',sans-serif}
        .pg-btn:hover:not(:disabled){border-color:#fd7e14!important;color:#fd7e14!important}
        .pg-btn:disabled{opacity:.3;cursor:default}
        .btn-p{display:inline-flex;align-items:center;gap:8px;padding:10px 18px;background:#198754;color:#fff;border:none;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;transition:all .2s;font-family:'Plus Jakarta Sans',sans-serif}
        .btn-p:hover:not(:disabled){background:#157347;transform:translateY(-1px)}
        .btn-p:disabled{opacity:.45;cursor:not-allowed}
        .btn-g{display:inline-flex;align-items:center;gap:8px;padding:10px 18px;background:transparent;border:1.5px solid;border-radius:10px;font-size:13px;font-weight:600;cursor:pointer;transition:all .2s;font-family:'Plus Jakarta Sans',sans-serif}
        .st-btn{display:flex;align-items:center;gap:8px;padding:9px 15px;border-radius:9px;font-size:13px;font-weight:600;cursor:pointer;border:1.5px solid;transition:all .2s;font-family:'Plus Jakarta Sans',sans-serif}
        .kpi-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:20px}
        .act-btn{width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:12px;cursor:pointer;border:1.5px solid;transition:all .18s}
        @media(max-width:1024px){.ct-main{margin-left:0!important}.kpi-grid{grid-template-columns:repeat(2,1fr)!important}}
        @media(max-width:640px){.kpi-grid{grid-template-columns:1fr 1fr!important}.ct-body{padding:14px}}
      `}</style>

      <ToastContainer toasts={toasts} />
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <Navbar  sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} pageTitle="Contacts" />

      <main className="ct-main" style={{marginLeft:mainML,paddingTop:mainPT}}>
        <div className="ct-body">

          {/* ── En-tête ── */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:22,flexWrap:'wrap',gap:12}}>
            <div style={{display:'flex',alignItems:'center',gap:14}}>
              <div style={{width:46,height:46,borderRadius:13,background:'#1a2535',color:'#fd7e14',display:'flex',alignItems:'center',justifyContent:'center',fontSize:19}}>
                <FaInbox />
              </div>
              <div>
                <h1 style={{fontSize:22,fontWeight:800,color:c.title,letterSpacing:'-.3px'}}>Gestion des Contacts</h1>
                <p style={{fontSize:13,color:c.textDim,marginTop:2}}>Suivi et traitement des demandes reçues via le site web</p>
              </div>
            </div>
            <button className="btn-p" style={{background:'#1a2535'}} onClick={exportCSV}>
              <FaDownload style={{fontSize:12}} /> Exporter CSV
            </button>
          </div>

          {/* ── KPI Cards ── */}
          <div className="kpi-grid">
            {[
              {n:stats.total,    l:'Total messages', icon:<FaInbox />,       accent:'#1a2535'},
              {n:stats.nouveau,  l:'Nouveaux',       icon:<FaBell />,        accent:'#fd7e14'},
              {n:stats.en_cours, l:'En cours',       icon:<FaClock />,       accent:'#fd7e14'},
              {n:stats.repondu,  l:'Répondus',       icon:<FaCheckDouble />, accent:'#198754'},
            ].map((k,i) => (
              <div key={i} style={{background:c.card,border:`1px solid ${c.cardB}`,borderTop:`3px solid ${k.accent}`,borderRadius:14,padding:'18px 20px',display:'flex',alignItems:'center',gap:14,boxShadow:c.shadow}}>
                <div style={{width:42,height:42,borderRadius:11,background:k.accent==='#198754'?'rgba(25,135,84,.1)':k.accent==='#fd7e14'?'rgba(253,126,20,.1)':'rgba(26,37,53,.08)',color:k.accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:17,flexShrink:0}}>
                  {loadingStats ? <Spin /> : k.icon}
                </div>
                <div>
                  <div style={{fontSize:28,fontWeight:800,color:c.title,lineHeight:1,letterSpacing:'-1px'}}>{loadingStats?'…':(k.n??0)}</div>
                  <div style={{fontSize:11,fontWeight:700,color:c.textDim,textTransform:'uppercase',letterSpacing:'.7px',marginTop:4}}>{k.l}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Filtres ── */}
          <div style={{display:'flex',gap:10,alignItems:'center',marginBottom:14,flexWrap:'wrap'}}>
            <div style={{flex:1,minWidth:260,display:'flex',alignItems:'center',gap:10,background:c.input,border:`1.5px solid ${c.inputB}`,borderRadius:11,padding:'0 14px',height:43}}>
              <FaSearch style={{color:c.textDim,fontSize:13,flexShrink:0}} />
              <input style={{flex:1,border:'none',outline:'none',fontSize:13,background:'transparent',color:c.inputT}} placeholder="Rechercher par nom, email, sujet…" value={searchQuery} onChange={e=>{setSearchQuery(e.target.value);setCurrentPage(1);}} />
              {searchQuery && <button onClick={()=>setSearchQuery('')} style={{background:'none',border:'none',cursor:'pointer',color:c.textDim}}><FaTimes /></button>}
            </div>
            <select style={inputS} value={filterStatus} onChange={e=>{setFilterStatus(e.target.value);setCurrentPage(1);}}>
              <option value="all">Tous les statuts</option>
              {Object.entries(STATUS_CFG).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
            </select>
            <select style={inputS} value={filterTag} onChange={e=>{setFilterTag(e.target.value);setCurrentPage(1);}}>
              <option value="all">Toutes catégories</option>
              {Object.keys(SUJET_TAGS).map(t => <option key={t} value={t}>{t}</option>)}
            </select>
            <span style={{fontSize:12,fontWeight:700,color:c.textDim,whiteSpace:'nowrap'}}>{totalItems} message{totalItems>1?'s':''}</span>
          </div>

          {/* ── Liste ── */}
          <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:16}}>
            {loading ? [...Array(5)].map((_,i) => <Sk key={i} h={90} r={13} />)
              : contacts.length===0
                ? <div style={{textAlign:'center',padding:'56px 20px',background:c.card,borderRadius:14,border:`1.5px dashed ${c.cardB}`}}>
                    <FaInbox style={{fontSize:40,color:c.textDim,display:'block',margin:'0 auto 12px'}} />
                    <p style={{fontSize:14,color:c.textDim,fontWeight:500}}>Aucun message.</p>
                  </div>
                : contacts.map(msg => {
                    const st  = STATUS_CFG[msg.statut] || STATUS_CFG.nouveau;
                    const tag = SUJET_TAGS[msg.tag]    || SUJET_TAGS['Information'];
                    return (
                      <div key={msg.id} className="ct-card-wrap" onClick={()=>openModal(msg)} style={{cursor:'pointer'}}>
                        <div className="ct-card-inner" style={{
                          background:c.card,
                          border:`1px solid ${msg.statut==='nouveau'?'rgba(253,126,20,.3)':c.cardB}`,
                          borderLeft:`3px solid ${msg.statut==='nouveau'?'#fd7e14':c.cardB}`,
                          borderRadius:13,padding:'14px 16px',display:'flex',alignItems:'center',gap:13,boxShadow:c.shadow,
                        }}>
                          {/* Avatar */}
                          <div style={{width:42,height:42,borderRadius:10,background:getAVBg(msg.nom_complet),display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:'#fff',flexShrink:0,position:'relative'}}>
                            {initials(msg.nom_complet)}
                            {msg.statut==='nouveau' && <div style={{position:'absolute',top:-3,right:-3,width:9,height:9,borderRadius:'50%',background:'#fd7e14',border:`2px solid ${c.card}`}} />}
                          </div>
                          {/* Contenu */}
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:3,gap:8}}>
                              <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
                                <span style={{fontSize:14,fontWeight:700,color:c.title}}>{msg.nom_complet}</span>
                                {msg.entreprise!=='Indépendant(e)' && <span style={{fontSize:12,color:c.textDim,display:'flex',alignItems:'center',gap:4}}><FaBuilding style={{fontSize:10}}/>{msg.entreprise}</span>}
                              </div>
                              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                                <span style={{fontSize:11,fontWeight:700,color:'#fd7e14',background:'rgba(253,126,20,.08)',padding:'2px 7px',borderRadius:5}}>{msg.ref}</span>
                                <span style={{fontSize:11,color:c.textDim}}><FaCalendarAlt style={{fontSize:9,marginRight:3}}/>{fmtDate(msg.created_at)}</span>
                              </div>
                            </div>
                            <div style={{fontSize:13,fontWeight:700,color:c.text,marginBottom:3,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{msg.sujet}</div>
                            <div style={{fontSize:12,color:c.textDim,marginBottom:8,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{msg.message?.slice(0,100)}…</div>
                            <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
                              <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:'2px 8px',borderRadius:5,fontSize:11,fontWeight:700,background:tag.bg,color:tag.color}}><FaTag style={{fontSize:8}}/>{msg.tag||'Information'}</span>
                              <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:'2px 8px',borderRadius:5,fontSize:11,fontWeight:700,border:'1px solid',color:st.color,background:st.bg,borderColor:st.border}}><FaCircle style={{fontSize:5}}/>{st.label}</span>
                              {msg.reponses?.length>0 && <span style={{fontSize:11,fontWeight:700,color:'#198754',background:'rgba(25,135,84,.08)',padding:'2px 8px',borderRadius:5,display:'inline-flex',alignItems:'center',gap:4}}><FaReply style={{fontSize:9}}/>{msg.reponses.length} réponse{msg.reponses.length>1?'s':''}</span>}
                              {msg.notes?.length>0 && <span style={{fontSize:11,fontWeight:700,color:c.textDim,background:c.surface,padding:'2px 8px',borderRadius:5,display:'inline-flex',alignItems:'center',gap:4}}><FaStickyNote style={{fontSize:9}}/>{msg.notes.length} note{msg.notes.length>1?'s':''}</span>}
                            </div>
                          </div>
                          {/* Actions rapides */}
                          <div style={{display:'flex',gap:5,flexShrink:0}} onClick={e=>e.stopPropagation()}>
                            {[
                              {icon:<FaEye/>,    onClick:()=>openModal(msg,'message'),  hC:'#fff',hBg:'#1a2535',dC:c.textDim},
                              {icon:<FaReply/>,  onClick:()=>openModal(msg,'repondre'), hC:'#fff',hBg:'#fd7e14',dC:'#fd7e14'},
                              {icon:<FaTrash/>,  onClick:()=>handleDelete(msg.id),     hC:'#fff',hBg:'#dc3545',dC:'#dc3545'},
                            ].map((btn,i) => (
                              <button key={i} className="act-btn" style={{color:btn.dC,background:c.input,borderColor:c.cardB}} onClick={btn.onClick}
                                onMouseEnter={e=>{e.currentTarget.style.background=btn.hBg;e.currentTarget.style.color=btn.hC;e.currentTarget.style.borderColor=btn.hBg;}}
                                onMouseLeave={e=>{e.currentTarget.style.background=c.input;e.currentTarget.style.color=btn.dC;e.currentTarget.style.borderColor=c.cardB;}}>
                                {inProg('delete-'+msg.id)&&btn.icon.type===FaTrash?<Spin/>:btn.icon}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })
            }
          </div>

          {/* ── Pagination ── */}
          {totalPages>1 && (
            <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap',padding:'10px 0'}}>
              <button className="pg-btn" style={{border:`1.5px solid ${c.cardB}`,background:c.card,color:c.text}} onClick={()=>setCurrentPage(1)} disabled={currentPage===1}>«</button>
              <button className="pg-btn" style={{border:`1.5px solid ${c.cardB}`,background:c.card,color:c.text}} onClick={()=>setCurrentPage(p=>Math.max(p-1,1))} disabled={currentPage===1}><FaChevronLeft/></button>
              {[...Array(totalPages)].map((_,i)=>i+1).map(p=>(
                <button key={p} className="pg-btn" onClick={()=>setCurrentPage(p)}
                  style={{border:`1.5px solid ${currentPage===p?'#198754':c.cardB}`,background:currentPage===p?'#198754':c.card,color:currentPage===p?'#fff':c.text}}>
                  {p}
                </button>
              ))}
              <button className="pg-btn" style={{border:`1.5px solid ${c.cardB}`,background:c.card,color:c.text}} onClick={()=>setCurrentPage(p=>Math.min(p+1,totalPages))} disabled={currentPage===totalPages}><FaChevronRight/></button>
              <button className="pg-btn" style={{border:`1.5px solid ${c.cardB}`,background:c.card,color:c.text}} onClick={()=>setCurrentPage(totalPages)} disabled={currentPage===totalPages}>»</button>
              <span style={{fontSize:12,color:c.textDim,fontWeight:600,marginLeft:'auto'}}>Page {currentPage}/{totalPages} — {totalItems} messages</span>
            </div>
          )}
        </div>
      </main>

      {/* ── MODAL ── */}
      {showModal && selectedMsg && (
        <div className="mo-overlay" style={{background:c.overlay,backdropFilter:'blur(8px)'}} onClick={closeModal}>
          <div className="mo-panel" style={{background:c.card,boxShadow:'0 24px 80px rgba(0,0,0,.2)'}} onClick={e=>e.stopPropagation()}>

            {/* Head */}
            <div style={{display:'flex',alignItems:'center',gap:14,padding:'16px 20px',borderBottom:`1px solid ${c.divider}`,background:c.surface,flexShrink:0}}>
              <div style={{width:44,height:44,borderRadius:11,background:getAVBg(selectedMsg.nom_complet),display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:'#fff',flexShrink:0}}>
                {initials(selectedMsg.nom_complet)}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:15,fontWeight:800,color:c.title}}>{selectedMsg.nom_complet}</div>
                <div style={{fontSize:12,color:c.textDim,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{selectedMsg.entreprise} · {selectedMsg.email}</div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                {(() => { const st = STATUS_CFG[selectedMsg.statut]||STATUS_CFG.nouveau; return (
                  <span style={{display:'inline-flex',alignItems:'center',gap:5,padding:'4px 10px',borderRadius:7,fontSize:11,fontWeight:700,border:'1px solid',color:st.color,background:st.bg,borderColor:st.border}}>
                    <FaCircle style={{fontSize:5}}/>{st.label}
                  </span>
                );})()}
                <button onClick={closeModal} style={{width:32,height:32,borderRadius:8,border:`1.5px solid ${c.cardB}`,background:c.card,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,color:c.textDim,cursor:'pointer'}}
                  onMouseEnter={e=>{e.currentTarget.style.background='#dc3545';e.currentTarget.style.color='#fff';e.currentTarget.style.borderColor='#dc3545';}}
                  onMouseLeave={e=>{e.currentTarget.style.background=c.card;e.currentTarget.style.color=c.textDim;e.currentTarget.style.borderColor=c.cardB;}}>
                  <FaTimes/>
                </button>
              </div>
            </div>

            {/* Tabs */}
            <div style={{display:'flex',gap:4,padding:'10px 16px',borderBottom:`1px solid ${c.divider}`,flexShrink:0,flexWrap:'wrap',background:c.card}}>
              {[
                {id:'message',  icon:<FaEnvelope/>, label:'Message'},
                {id:'repondre', icon:<FaReply/>,    label:'Répondre'},
                {id:'traiter',  icon:<FaEdit/>,     label:'Traitement'},
                {id:'historique',icon:<FaHistory/>, label:'Historique'},
              ].map(t => (
                <button key={t.id} className="mo-tab" onClick={()=>setModalTab(t.id)}
                  style={{background:modalTab===t.id?'#198754':'transparent',color:modalTab===t.id?'#fff':c.text}}>
                  {t.icon}{t.label}
                </button>
              ))}
            </div>

            {/* Scroll body */}
            <div style={{overflowY:'auto',flex:1,background:c.bg}}>
              <div style={{padding:18,display:'flex',flexDirection:'column',gap:10}}>

                {/* ── MESSAGE ── */}
                {modalTab==='message' && (
                  <>
                    <Block title="Expéditeur">
                      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',border:`1px solid ${c.cardB}`,borderRadius:10,overflow:'hidden'}}>
                        {[
                          {l:'Nom complet',v:selectedMsg.nom_complet},
                          {l:'Entreprise', v:selectedMsg.entreprise},
                          {l:'Email',      v:<a href={`mailto:${selectedMsg.email}`} style={{color:'#fd7e14',textDecoration:'none',fontWeight:700}}>{selectedMsg.email}</a>},
                          {l:'Téléphone',  v:selectedMsg.telephone},
                          {l:'Référence',  v:<span style={{fontSize:12,fontWeight:700,color:'#fd7e14',background:'rgba(253,126,20,.08)',padding:'2px 8px',borderRadius:5}}>{selectedMsg.ref}</span>},
                          {l:'Reçu le',    v:selectedMsg.created_at_human},
                        ].map((it,i) => (
                          <div key={i} style={{padding:'10px 13px',borderRight:i%3!==2?`1px solid ${c.cardB}`:'none',borderBottom:i<3?`1px solid ${c.cardB}`:'none'}}>
                            <div style={{fontSize:9,fontWeight:700,color:c.textDim,textTransform:'uppercase',letterSpacing:'.6px',marginBottom:3}}>{it.l}</div>
                            <div style={{fontSize:13,fontWeight:500,color:c.title}}>{it.v}</div>
                          </div>
                        ))}
                      </div>
                    </Block>

                    <Block>
                      <div style={{display:'flex',alignItems:'center',gap:12,background:c.surface,padding:'11px 13px',borderRadius:9,border:`1px solid ${c.cardB}`}}>
                        <span style={{fontSize:14,fontWeight:700,color:c.title,flex:1,lineHeight:1.4}}>{selectedMsg.sujet}</span>
                        <span style={{display:'inline-flex',alignItems:'center',gap:5,padding:'3px 10px',borderRadius:6,fontSize:11,fontWeight:700,background:SUJET_TAGS[selectedMsg.tag]?.bg||SUJET_TAGS['Information'].bg,color:SUJET_TAGS[selectedMsg.tag]?.color||SUJET_TAGS['Information'].color,flexShrink:0}}>
                          <FaTag style={{fontSize:9}}/>{selectedMsg.tag||'Information'}
                        </span>
                      </div>
                    </Block>

                    <Block title="Message">
                      <div style={{background:c.surface,border:`1px solid ${c.cardB}`,borderRadius:9,padding:'14px 16px',fontSize:14,lineHeight:1.8,color:c.text,whiteSpace:'pre-wrap'}}>
                        {selectedMsg.message}
                      </div>
                    </Block>

                    {selectedMsg.reponses?.length>0 && (
                      <Block title="Réponses envoyées">
                        {selectedMsg.reponses.map((r,i) => (
                          <div key={i} style={{background:'rgba(25,135,84,.04)',border:'1px solid rgba(25,135,84,.15)',borderLeft:'3px solid #198754',borderRadius:9,padding:'11px 13px',marginBottom:i<selectedMsg.reponses.length-1?8:0}}>
                            <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                              <span style={{fontSize:12,fontWeight:700,color:'#198754'}}>{r.auteur}</span>
                              <span style={{fontSize:11,color:c.textDim}}>{r.date}</span>
                            </div>
                            <p style={{fontSize:13,color:c.text,lineHeight:1.7}}>{r.texte}</p>
                          </div>
                        ))}
                      </Block>
                    )}

                    <Block>
                      <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                        <button className="btn-p" style={{background:'rgba(253,126,20,.08)',color:'#fd7e14',border:'1.5px solid rgba(253,126,20,.25)',borderRadius:10}}
                          onMouseEnter={e=>{e.currentTarget.style.background='#fd7e14';e.currentTarget.style.color='#fff';}}
                          onMouseLeave={e=>{e.currentTarget.style.background='rgba(253,126,20,.08)';e.currentTarget.style.color='#fd7e14';}}
                          onClick={()=>setModalTab('repondre')}>
                          <FaReply/>Répondre
                        </button>
                        <button className="btn-g" style={{borderColor:c.cardB,color:c.text}} onClick={()=>setModalTab('traiter')}>
                          <FaEdit/>Traiter
                        </button>
                      </div>
                    </Block>
                  </>
                )}

                {/* ── RÉPONDRE ── */}
                {modalTab==='repondre' && (
                  <Block title="Composer une réponse">
                    <div style={{background:c.surface,border:`1px solid ${c.cardB}`,borderRadius:9,padding:'11px 13px',marginBottom:12}}>
                      <div style={{fontSize:10,fontWeight:700,color:c.textDim,textTransform:'uppercase',letterSpacing:'.6px',marginBottom:5}}>Message original de {selectedMsg.nom_complet}</div>
                      <div style={{fontSize:13,color:c.text,lineHeight:1.6}}><strong>Sujet :</strong> {selectedMsg.sujet}<br/><em>« {selectedMsg.message?.slice(0,160)}… »</em></div>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:9,padding:'9px 13px',background:'rgba(25,135,84,.05)',border:'1px solid rgba(25,135,84,.15)',borderRadius:9,marginBottom:12}}>
                      <span style={{fontSize:12,fontWeight:800,color:'#198754'}}>À :</span>
                      <span style={{fontSize:13,color:c.title,fontWeight:600}}>{selectedMsg.email}</span>
                    </div>
                    <div style={{border:`1.5px solid ${c.inputB}`,borderRadius:11,overflow:'hidden',marginBottom:12}}>
                      <div style={{padding:'10px 14px',borderBottom:`1px solid ${c.divider}`,fontSize:13,color:c.textDim,fontStyle:'italic',background:c.surface}}>
                        Bonjour {selectedMsg.nom_complet?.split(' ')[0]},
                      </div>
                      <textarea className="ct-ta" rows={8} value={replyText} onChange={e=>setReplyText(e.target.value)} placeholder="Rédigez votre réponse ici…" style={{background:c.card,border:'none',color:c.inputT}} />
                      <div style={{padding:'10px 14px',borderTop:`1px solid ${c.divider}`,fontSize:12,color:c.textDim,lineHeight:1.8,background:c.surface}}>
                        Cordialement,<br/><strong>L'équipe CINEF Formation</strong>
                      </div>
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <button className="btn-p" onClick={handleReply} disabled={!replyText.trim()||inProg('reply')}>
                        {inProg('reply')?<><Spin/>Envoi…</>:<><FaPaperPlane style={{fontSize:12}}/>Envoyer la réponse</>}
                      </button>
                      <button className="btn-g" style={{borderColor:c.cardB,color:c.textDim}} onClick={()=>setReplyText('')}>Effacer</button>
                    </div>
                    {selectedMsg.reponses?.length>0 && (
                      <div style={{marginTop:14}}>
                        <div style={{fontSize:11,fontWeight:700,color:c.textDim,textTransform:'uppercase',letterSpacing:'.7px',marginBottom:10}}>Échanges précédents ({selectedMsg.reponses.length})</div>
                        {selectedMsg.reponses.map((r,i) => (
                          <div key={i} style={{background:'rgba(25,135,84,.04)',border:'1px solid rgba(25,135,84,.15)',borderLeft:'3px solid #198754',borderRadius:9,padding:'11px 13px',marginBottom:8}}>
                            <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                              <span style={{fontSize:12,fontWeight:700,color:'#198754'}}>{r.auteur}</span>
                              <span style={{fontSize:11,color:c.textDim}}>{r.date}</span>
                            </div>
                            <p style={{fontSize:13,color:c.text,lineHeight:1.7}}>{r.texte}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </Block>
                )}

                {/* ── TRAITEMENT ── */}
                {modalTab==='traiter' && (
                  <>
                    <Block title="Changer le statut">
                      <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                        {Object.entries(STATUS_CFG).map(([key,cfg]) => {
                          const isOn = selectedMsg.statut===key;
                          return (
                            <button key={key} className="st-btn" style={{background:cfg.bg,color:cfg.color,borderColor:cfg.border,opacity:isOn?1:.75}}
                              onClick={()=>handleChangeStatut(selectedMsg.id,key)} disabled={!!actionLoad}>
                              {inProg('statut-'+selectedMsg.id)?<Spin/>:(
                                key==='nouveau'?<FaBell style={{fontSize:12}}/>:key==='en_cours'?<FaClock style={{fontSize:12}}/>:key==='repondu'?<FaCheckCircle style={{fontSize:12}}/>:<FaArchive style={{fontSize:12}}/>
                              )}
                              {cfg.label}
                              {isOn && <span style={{fontSize:10,background:'rgba(255,255,255,.3)',borderRadius:4,padding:'1px 6px',marginLeft:3}}>✓</span>}
                            </button>
                          );
                        })}
                      </div>
                    </Block>

                    <Block title="Notes internes">
                      {selectedMsg.notes?.length===0 && <p style={{fontSize:13,color:c.textDim,fontStyle:'italic',marginBottom:12}}>Aucune note.</p>}
                      {selectedMsg.notes?.map((n,i) => (
                        <div key={i} style={{background:c.surface,border:`1px solid ${c.cardB}`,borderLeft:'3px solid #fd7e14',borderRadius:9,padding:'10px 13px',marginBottom:8}}>
                          <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                            <span style={{fontSize:12,fontWeight:700,color:'#fd7e14'}}>{n.auteur}</span>
                            <span style={{fontSize:11,color:c.textDim}}>{n.date}</span>
                          </div>
                          <p style={{fontSize:13,color:c.text,lineHeight:1.6}}>{n.texte}</p>
                        </div>
                      ))}
                      <textarea className="ct-ta" rows={3} value={noteText} onChange={e=>setNoteText(e.target.value)} placeholder="Ajouter une note interne (visible uniquement par les admins)…" style={{background:c.input,border:`1.5px solid ${c.inputB}`,color:c.inputT,marginBottom:9}} />
                      <button className="btn-p" style={{background:'#1a2535'}} onClick={handleAddNote} disabled={!noteText.trim()||inProg('note')}
                        onMouseEnter={e=>e.currentTarget.style.background='#fd7e14'}
                        onMouseLeave={e=>e.currentTarget.style.background='#1a2535'}>
                        {inProg('note')?<><Spin/>Ajout…</>:<><FaStickyNote style={{fontSize:12}}/>Ajouter la note</>}
                      </button>
                    </Block>

                    <Block style={{border:'1px solid rgba(220,53,69,.2)',background:isDark?'rgba(220,53,69,.03)':'rgba(220,53,69,.01)'}}>
                      <div style={{fontSize:11,fontWeight:700,color:'#dc3545',textTransform:'uppercase',letterSpacing:'.7px',marginBottom:10,display:'flex',alignItems:'center',gap:7}}><FaExclamationTriangle/>Zone dangereuse</div>
                      <p style={{fontSize:13,color:c.textDim,marginBottom:12,lineHeight:1.6}}>Cette action est irréversible. Le message sera définitivement supprimé.</p>
                      <button style={{display:'flex',alignItems:'center',gap:8,padding:'10px 16px',background:'transparent',border:'1.5px solid rgba(220,53,69,.3)',color:'#dc3545',borderRadius:9,fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:"'Plus Jakarta Sans',sans-serif",transition:'all .2s'}}
                        onMouseEnter={e=>{e.currentTarget.style.background='#dc3545';e.currentTarget.style.color='#fff';}}
                        onMouseLeave={e=>{e.currentTarget.style.background='transparent';e.currentTarget.style.color='#dc3545';}}
                        onClick={()=>handleDelete(selectedMsg.id)} disabled={inProg('delete-'+selectedMsg.id)}>
                        {inProg('delete-'+selectedMsg.id)?<Spin/>:<FaTrash/>} Supprimer définitivement
                      </button>
                    </Block>
                  </>
                )}

                {/* ── HISTORIQUE ── */}
                {modalTab==='historique' && (
                  <Block title="Historique des actions">
                    <div style={{display:'flex',flexDirection:'column'}}>
                      {(selectedMsg.historique||[]).map((h,i,arr) => {
                        const dc = HISTO_C[h.icone]||'#8fa3b5';
                        return (
                          <div key={i} style={{display:'flex',gap:13,paddingBottom:i<arr.length-1?16:0}}>
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',flexShrink:0}}>
                              <div style={{width:28,height:28,borderRadius:'50%',background:dc+'18',border:`2px solid ${dc}40`,color:dc,display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,flexShrink:0}}><FaCircle/></div>
                              {i<arr.length-1 && <div style={{width:2,flex:1,minHeight:14,background:c.divider}} />}
                            </div>
                            <div style={{paddingTop:4}}>
                              <div style={{fontSize:13,fontWeight:600,color:c.title}}>{h.action}</div>
                              <div style={{fontSize:11,color:c.textDim,marginTop:2}}>{h.date}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Block>
                )}

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactAdmin;